import { render, staticRenderFns } from "./sidebar-close-button.vue?vue&type=template&id=244c7016&scoped=true&"
import script from "./sidebar-close-button.vue?vue&type=script&lang=ts&"
export * from "./sidebar-close-button.vue?vue&type=script&lang=ts&"
import style0 from "./sidebar-close-button.vue?vue&type=style&index=0&id=244c7016&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244c7016",
  null
  
)

export default component.exports